import React from 'react';

export interface BlockRendererProps {
  block: { settings: Record<string, any> };
  config: {
    anaRenk: string;
    aksanRenk: string;
    font: string;
    fontBoyutu: number;
    odemeKosullari?: string;
    gecerlilikNotu?: string;
    altBilgiNotu?: string;
  };
  offer?: any;
  offerType?: 'given' | 'received';
  companyInfo?: any;
}

const BankAccountsBlockRenderer: React.FC<BlockRendererProps> = ({ block, config, companyInfo }) => {
  const s = block?.settings ?? {};
  const showHeader = s.showHeader !== false;

  const settingsAccounts = Array.isArray(s.accounts) && s.accounts.length > 0
    ? s.accounts.filter((a: any) => a?.bankName || a?.iban)
    : null;
  const accounts = settingsAccounts || (Array.isArray(companyInfo?.bankAccounts) ? companyInfo.bankAccounts : []);

  const fs = `${Math.max(config.fontBoyutu - 1, 10)}px`;

  const th: React.CSSProperties = {
    padding: '8px 10px',
    fontSize: fs,
    fontWeight: 700,
    textAlign: 'left' as const,
    borderBottom: `2px solid ${config.aksanRenk}`,
    color: '#333',
  };

  const td: React.CSSProperties = {
    padding: '7px 10px',
    fontSize: fs,
    borderBottom: '1px solid #eee',
  };

  if (accounts.length === 0) return null;

  return (
    <div style={{ width: '100%', fontFamily: `'${config.font}', Arial, sans-serif` }}>
      {showHeader ? (
        <div style={{ fontWeight: 700, marginBottom: 8, color: config.anaRenk, fontSize: `${config.fontBoyutu}px` }}>Banka Hesapları</div>
      ) : null}
      <table style={{ width: '100%', borderCollapse: 'collapse' as const }}>
        <thead>
          <tr>
            <th style={th}>Banka</th>
            <th style={th}>IBAN</th>
          </tr>
        </thead>
        <tbody>
          {accounts.map((acc: any, idx: number) => (
            <tr key={idx}>
              <td style={td}>{acc?.bankName ? String(acc.bankName) : '-'}</td>
              <td style={{ ...td, fontFamily: 'monospace', wordBreak: 'break-all' as const }}>{acc?.iban ? String(acc.iban) : '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BankAccountsBlockRenderer;
